'use strict';

export default function f(modal, $rootScope, $ocLazyLoad, $q) {
  'ngInject';

  return {
    open: function (guide) {
      return $q((resolve) => {
        import('./request_reference_modal').then(() => {
          $ocLazyLoad.load({
            name: 'components.requestReferenceModal'
          });

          var scope = $rootScope.$new();
          scope.guide = guide;

          resolve(modal.open({
            template: '<sa-request-reference-modal done="close()" guide="guide"></sa-request-reference-modal>',
            scope: scope
          }).result);

        });
      });
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/components/request_reference/request_reference_modal/request_reference_modal.service.js